import classicBilAPI from '../classicApi';

export const patchSchool = (uuid, body) => {
  return new Promise((resolve, reject) => {
    try {
      classicBilAPI
        .patch(`/core/schools/${uuid}/`, body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

// Adds years to (mode 'add') or removes them from (mode 'remove') many schools.
// The schools' other years are kept, unlike patchSchool, which replaces them.
export const bulkUpdateSchoolYears = ({ schools, years, mode }) => {
  return classicBilAPI
    .patch('/core/schools/bulk_years/', { schools, years, mode })
    .then((res) => res.data);
};
